import styled from 'styled-components';

export const Conatiner = styled.div`
  display: flex;
  margin: 0.5rem 0;
  @media only screen and (max-width: 960px) {
    flex-wrap: wrap;
  }
`;

export const Heading = styled.div`
  min-width: 400px;
  width: 450px;
  @media only screen and (max-width: 960px) {
    min-width: 100%;
    width: 100%;
  }
`;

export const Paragraph = styled.div`
  width: 100%;
`;
